/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorizationDto } from './authorizationDto';
import { ProjectDto } from './projectDto';
import { WorkCenterDto } from './workCenterDto';

export interface UserDto {
  username?: string;
  email?: string;
  fullName?: string;
  role?: UserDto.RoleEnum;
  sapId?: string;
  lastSeenVersion?: string;
  workCenters?: Array<WorkCenterDto>;
  projects?: Array<ProjectDto>;
  sites?: Array<string>;
  division?: UserDto.DivisionEnum;
  authorizations?: Array<AuthorizationDto>;
  projectAuthorizations?: Array<AuthorizationDto>;
  favouriteWorkOrders?: Array<string>;
  admin?: boolean;
  betaUser?: boolean;
}
export namespace UserDto {
  export const RoleEnum = {
    Foreman: 'FOREMAN',
    Operator: 'OPERATOR',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
  export const DivisionEnum = {
    Sls: 'SLS',
    Fabrication: 'FABRICATION',
    Offshore: 'OFFSHORE',
  } as const;
  export type DivisionEnum = (typeof DivisionEnum)[keyof typeof DivisionEnum];
}
